<script>
  import { getContext } from "svelte";
  import Button from "./Button.svelte";
  import { loadHighlight } from "../util/highlight-loader";

  const modal = getContext("modal");
  export let fitHeight = false;
  export let small = false;

  function click() {
    modal.show("mint", { title: "Mint" });
  }

  async function mouseOver() {
    // console.log("Loading highlight");
    await loadHighlight();
  }
</script>

<Button
  {fitHeight}
  text="Mint"
  hotkey="m"
  {small}
  publish
  on:mouseover={mouseOver}
  on:click={click}
></Button>
